import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

interface TimesheetLoadingValue {
    loading: boolean
}
  
const initialState: TimesheetLoadingValue = {
    loading: false
}

const approvalState: TimesheetLoadingValue = {
  loading: false
}

export const timesheetLoadingSlice = createSlice({
    name: 'timesheetLoading',
    initialState,
    reducers: {
      changeLoading: (state, action: PayloadAction<TimesheetLoadingValue>) => {
        state.loading = action.payload.loading
      }
    }
});

export const approvalLoadingSlice = createSlice({
  name: 'approvalLoading',
  initialState: approvalState,
  reducers: {
    approvalLoading: (state, action: PayloadAction<TimesheetLoadingValue>) => {
      state.loading = action.payload.loading
    }
  }
});

export const { changeLoading } = timesheetLoadingSlice.actions

export const { approvalLoading } = approvalLoadingSlice.actions
